export const columnFields = [
	'id',
	'parameterRef',
	'label',
	'defaultValue',
	'parameterType',
	'parameterTypeRef',
	'createdAt',
	'updatedAt',
] as const;
